export default __webpack_public_path__ + "static/media/emerald-checkbox.6a9cccda.svg";